<template>
    <div id="login-form-container">
        <div id="login-form-panel">
            <form id="login-form">
                <h1>Log in</h1>
                <input type="text" placeholder="Email..." v-model="email" @change="errors = []" ref="emailField"/>
                <input type="password" placeholder="Password..." v-model="password" @change="errors = []"/>

                <div class="remember-me checkbox-row">
                    <input type="checkbox" id="remember-me-check" v-model="rememberMe"/>
                    <label for="remember-me-check" class="fake-checkbox"></label>
                    <label for="remember-me-check" class="checkbox-description">Remember Me</label>
                </div>

                <div class="validation error" v-if="errors.length > 0">
                    <span v-for="error in errors">{{error}}</span>
                </div>

                <button @click.prevent="submit">Log In</button>
            </form>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import validator from 'validator';

    export default {
        name: 'LoginForm',

        data() {
            return {
                errors: [],
                email: '',
                password: '',
                rememberMe: true
            }
        },

        methods: {
            submit(){
                let errors = [];

                this.email = this.email.trim();

                if (!validator.isEmail(this.email)) {
                    errors.push('Invalid Email Address');
                }

                if (this.password === '') {
                    errors.push('Enter your Password')
                }


                if (errors.length > 0) {
                    this.errors = errors;
                    return;
                }

                this.isSaving = true;

                axios.post('/api/login', {
                    email: this.email,
                    password: this.password
                }).then(
                    (response) => {
                        if (response.data.errors) {
                            this.isSaving = false;
                            this.errors = response.data.errors;
                            return;
                        }

                        this.$store.dispatch('loggedUserModel/fetchLoggedUserInfo', () => {
                            this.$socket.emit("setUserSocketData", this.$store.state.loggedUserModel.info);
                            this.$router.push('/Chat');
                        });

                    },
                    (response) => {
                        this.isSaving = false;
                        this.errors = ['There was a problem connecting to the Database. Please wait a minute and try again.'];
                    }
                )
            }
        },

        mounted(){
            this.$refs.emailField.focus();
        }
    }
</script>


// WEBPACK FOOTER //
// LoginForm.vue?7ceddf78